module.exports = __webpack_public_path__ + "static/media/leather_strap_black_white.f2d582e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/leather_strap_black_white.png
// module id = 105
// module chunks = 0